export default __webpack_public_path__ + "static/media/userCalenderFilter.2fdaeb71.svg";